// "Izlashga yozilgan ma'lumotlarni saqlab qolish" sozlamasi (settings.saveSearch) yoqilganda
// har bir sahifaning izlash maydoniga yozilgan matn shu yerda saqlanadi.
// sessionStorage ishlatiladi -- tizimdan chiqilganda clearTemporaryStorage() uni tozalaydi.
const STORAGE_KEY = 'savedSearches'

function readAll() {
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY)
		const parsed = raw ? JSON.parse(raw) : null
		return parsed && typeof parsed === 'object' ? parsed : {}
	} catch (error) {
		return {}
	}
}

export function getSavedSearch(key) {
	if (!key) return ''
	const value = readAll()[key]
	return typeof value === 'string' ? value : ''
}

export function setSavedSearch(key, value) {
	if (!key) return
	const all = readAll()
	if (value) {
		all[key] = value
	} else {
		delete all[key]
	}
	try {
		sessionStorage.setItem(STORAGE_KEY, JSON.stringify(all))
	} catch (error) {
		// Ignore write errors.
	}
}

export function clearSavedSearches() {
	try {
		sessionStorage.removeItem(STORAGE_KEY)
	} catch (error) {
		// Ignore write errors.
	}
}
